import { PageController } from '@client/components/_core/layout/PageController';
import { ENABLE_CLAIM_PAYMENT_APPROVAL_FLAG } from '@shared/constants';
import { createFileRoute } from '@tanstack/react-router';
import { InsurerLimitDrawer } from './InsurerLimitDrawer';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/claims/claims-authority/insurer-limits/add',
)({
    staticData: {
        presentation: 'overlay',
        // CUR-2674: the section that opens it shows only with payment approval; the server answers NOT_FOUND without it.
        featureFlag: ENABLE_CLAIM_PAYMENT_APPROVAL_FLAG,
        metadata: {
            title: 'New insurer limit',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <InsurerLimitDrawer target={null} />
        </PageController>
    );
}
